




























































































































































































































































































import mixins from 'vue-typed-mixins';
import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import ErrorListMixin from '@/Shared/ErrorListMixin';
import Permit from './Permit';
import PermitCustomer from './PermitCustomer';
import CustomerEdit from '@/Customer/CustomerEdit.vue';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import GeneralLookupDropdown from '@/Shared/GeneralLookupDropdown.vue';
import PermitVariables from './PermitVariables';
import PermitType from './PermitType';
import PermitTypeSelect from './PermitTypeSelect.vue';
import PermitVehicleForm from './PermitVehicleForm.vue';
import { Dictionary } from 'vue-router/types/router';
import PermitVehicle from './PermitVehicle';
import PermitAttachment from './PermitAttachment';
import { Location } from '@/Stores/UserStore';
import { CustomerRequiredFields } from '@/Customer/CustomerRequiredFields';
import { User } from '@/Stores/UserStore';
import RadioToggle from '@/Shared/RadioToggle.vue';
import PermitApplicationDocument from './PermitApplicationDocument';
import constants from '@/constants';
import fileSaver from 'file-saver';
import { Logger } from '@/Shared/Logger';
import { AxiosResponse } from 'axios';
import { BTab, BTabs } from 'bootstrap-vue';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import NotesEditor from '@/Admin/Notes/NotesEditor.vue';
import Note from '@/Admin/Notes/Note';
import I18nMixin from '@/Shared/I18nMixin';
import UserMixin from '@/Shared/UserMixin';
import { CustomerFieldVisibility, FieldVisibility } from '@/Customer/CustomerFieldVisibility';
import { TranslateResult } from 'vue-i18n';
import { getQuarterCount, getDaysMonth, countDays } from '@/Shared/DateFunctions';

const msgBoxOptions = {
    centered: true,
    okVariant: 'danger',
    modalClass: 'deleteRowClass',
    hideBackdrop: true
};

const externalCustomerRequiredFields: Partial<CustomerRequiredFields> = {
    firstName: true,
    lastName: true,
    address1: true,
    address2: false,
    city: true,
    state: true,
    zip: true,
    phoneNumber: false,
    emailAddress: true,
};

const internalCustomerRequiredFields: Partial<CustomerRequiredFields> = {
    firstName: true,
    lastName: true,
    address1: true,
    address2: false,
    city: true,
    state: true,
    zip: true,
    phoneNumber: false,
    emailAddress: true,
};

const internalCustomerFieldVisibility: Partial<CustomerFieldVisibility> = {
    recID: FieldVisibility.Enabled,
    firstName: FieldVisibility.Enabled,
    lastName:  FieldVisibility.Enabled,
    address1:  FieldVisibility.Enabled,
    address2:  FieldVisibility.Enabled,
    city:  FieldVisibility.Enabled,
    state:  FieldVisibility.Enabled,
    zip:  FieldVisibility.Enabled,
    phoneNumber:  FieldVisibility.Enabled,
    emailAddress:  FieldVisibility.Enabled
};

const externalCustomerFieldVisibility: Partial<CustomerFieldVisibility> = {
    recID: FieldVisibility.Hidden,
    firstName: FieldVisibility.Enabled,
    lastName:  FieldVisibility.Enabled,
    address1:  FieldVisibility.Enabled,
    address2:  FieldVisibility.Enabled,
    city:  FieldVisibility.Enabled,
    state:  FieldVisibility.Enabled,
    zip:  FieldVisibility.Enabled,
    phoneNumber:  FieldVisibility.Enabled,
    emailAddress:  FieldVisibility.Enabled
};

const PlaneState = 'PL';

const PermitApplication = mixins(LocationBasedMixin, ErrorListMixin, I18nMixin, UserMixin).extend({
    components: {
        LocationLookupDropdown,
        PermitTypeSelect,
        PermitVehicleForm,
        CustomerEdit,
        GeneralLookupDropdown,
        RadioToggle,
        NotesEditor
    },
    props: {
        location: {
            required: true,
            type: String
        },
        settings: {
            required: true,
            type: Object as () => PermitVariables
        }
    },
    data() {
        return {
            namePrefix: 'permit-application',
            activeTabName: '' as string | null,
            permit: { } as Permit,
            documentUploads: [] as File[],
            licenseUpload: null as File | null,
            vehicleRegistrationUpload: null as File | null,
            selectedPermitType: {} as PermitType | null,
            permitsAvailable: null as boolean | null,
            addingSharedVehicles: false,
            customer: {} as PermitCustomer,
            customerNotes: [] as Note[] | null,
            customerSearchResults: [] as PermitCustomer[],
            customerErrors: null as Dictionary<string[]> | null,
            tabIndex: 0 as number,
            tabCount: 0 as number,
            documents: null as PermitApplicationDocument[] | null,
            validCustomer: false as boolean,
            validationErrors: {} as { [propName: string]: string[] },
            submissionStatus: {
                customer: false,
                permit: false,
                permitTypeOverrides: false,
                documentUploads: false
            }
        };
    },
    async beforeMount() {
        await this.loadUser();
        if (this.settings.documentsRequired) {
            try {
                this.documents = (
                    await VatsAPI.get<PermitApplicationDocument[]>(`/${this.location}/Permits/documents`)
                ).data;
            }
            catch (e) {
                this.$bvToast.toast(
                    this.i18nLocal('documentRetrievalError').toString(),
                    {
                        title: this.i18nCommon('error').toString(),
                        autoHideDelay: 5000
                    }
                );
            }
        }

        if (this.settings.isAirfield) {
            // server sets this itself for creation, just setting
            // in case we want to display it
            this.permit.vehicleState = PlaneState;
        }
    },
    mounted() {
        this.updateTabCount();
        this.updateActiveTabName();
    },
    watch: {
        permit() {
            this.$emit('change', this.permit);
        },
        customer: {
            deep: true,
            handler() {
                if (this.submissionStatus.customer) {
                    this.submissionStatus.customer = false;

                    // online users cannot update their info through the permit application process
                    // changes made to the customer fields after submission cannot be tied to
                    // an existing customer object
                    if (!this.isInternal && this.existingCustomerSelected) {
                        this.customer.recID = 0;
                    }
                }
            }
        },
        async selectedPermitType() {
            if (this.selectedPermitType && typeof this.selectedPermitType.description === 'string') {
                try {
                    const response = (await VatsAPI.get<boolean>(`/${this.location}/Permits/permitTypeAvailable`,
                        { params: { description: this.selectedPermitType.description }}));

                    this.permitsAvailable = response.data;
                }
                catch (e) {
                    this.permitsAvailable = false;
                }
            }
        },
        permitsAvailable() {
            if (this.permitsAvailable) {
                this.clearError('permitsUnavailable');
            }
            else {
                this.addError('permitsUnavailable', this.i18nLocal('permitsUnavailable').toString());
            }
        },
        tabIndex() {
            this.updateTabCount();
            this.updateActiveTabName();
        }
    },
    computed: {
        i18nPrefix(): string { return 'permits.permitCreate'; },
        formattedInstructions(): string {
            const instructions = this.settings?.instructions ?? '';
            return instructions.split('\n').join('<br />');
        },
        formattedTermsAndConditions(): string {
            const termsConditions = this.settings?.termsConditions ?? '';
            return termsConditions.split('\n').join('<br />');
        },
        canNextTab(): boolean {
            if (this.activeTabName === `${this.namePrefix}-customer-tab`) {
                return !this.lastTabActive && this.validCustomer;
            }

            return !this.lastTabActive;
        },
        canPreviousTab(): boolean {
            return !this.firstTabActive;
        },
        canSubmit(): boolean {
            return (!this.submissionComplete && !!this.permitsAvailable && this.validCustomer);
        },
        submissionComplete(): boolean {
            return this.submissionStatus.documentUploads &&
                this.submissionStatus.permitTypeOverrides &&
                this.submissionStatus.permit &&
                this.submissionStatus.customer;
        },
        permitTypeSelected(): boolean {
            return !!this.selectedPermitType &&  typeof this.selectedPermitType!.recID === 'number';
        },
        customerRequiredFields(): Partial<CustomerRequiredFields> {
            return (this.isInternal) ? internalCustomerRequiredFields : externalCustomerRequiredFields;
        },
        customerFieldVisibility(): Partial<CustomerFieldVisibility> {
            let visibility = externalCustomerFieldVisibility;

            if (this.isInternal) {
                visibility = {...internalCustomerFieldVisibility};

                visibility.recID =
                    internalCustomerFieldVisibility.recID !== FieldVisibility.Hidden &&
                    this.existingCustomerSelected ? FieldVisibility.Disabled : FieldVisibility.Enabled;
            }

            return visibility;
        },
        documentsRequired(): boolean {
            return this.settings.documentsRequired;
        },
        firstTabActive(): boolean {
            return this.tabIndex === 0;
        },
        lastTabActive(): boolean {
            return this.tabIndex === (this.tabCount - 2);
        },
        showNotes(): boolean {
            return this.existingCustomerSelected;
        },
        permitCreationEndpoint(): string {
            return `/${this.location}/Permits/` + (this.isInternal ? 'create' : 'apply');
        },
        existingCustomerSelected(): boolean {
            return !!this.customer && !!this.customer.recID && this.customer.recID > 0;
        }
    },
    methods: {
        nextTab() {
            if (this.tabIndex === 1) {
                if (!this.checkDatesSelected()) {
                    const messageSaved: TranslateResult = this.$t('permits.permitCreate.dateError');
                    this.$bvModal.msgBoxConfirm(messageSaved.toString(), msgBoxOptions);
                } else {
                    this.tabIndex++;
                }
            } else {
                this.tabIndex++;
            }
        },
        previousTab() {
            this.tabIndex--;
        },
        locationChanged() {
            this.updateTabCount();
        },
        customerValidChanged(customerIsValid: boolean) {
            this.validCustomer = customerIsValid;
        },
        linkTabTitleClass(tabName: string) {
            if (this.activeTabName !== tabName) {
                if (this.$el && this.$el.querySelectorAll(`[name=${tabName}] .has-errors`).length > 0) {
                    return ['has-errors'];
                }

                if (tabName === `${this.namePrefix}-customer-tab`) {
                    if (!this.validCustomer) {
                        return ['has-errors'];
                    }
                }
            }
        },
        updateTabCount() {
            // $refs is not reactive--couldn't do this in a computed property
            this.tabCount = !!this.$refs &&
                            !!this.$refs.applicationTabs ?
                                (this.$refs.applicationTabs as Vue).$el.querySelectorAll('.tab-pane').length : 0;
        },
        updateActiveTabName() {
            // $refs is not reactive--couldn't do this in a computed property
            const tabsControl = !!this.$refs &&
                                !!this.$refs.applicationTabs ?
                                (this.$refs.applicationTabs as any) : {};

            if (!!tabsControl.getTabs) {
                const tabs: Vue[] = tabsControl.getTabs();
                const activeTab = tabs[this.tabIndex].$el;
                this.activeTabName = activeTab.getAttribute('name');
            }
        },
        resetsubmissionStatus() {
            this.submissionStatus = {
                customer: false,
                permit: false,
                permitTypeOverrides: false,
                documentUploads: false
            };
        },
        async uploadDocuments(permit: Permit) {
            const formData = new FormData();
            let success = false;

            this.documentUploads.forEach(document => {
                formData.append('files', document, document.name);
            });

            if (this.licenseUpload !== null) {
                formData.append('files', this.licenseUpload, this.licenseUpload.name);
            } 
            
            if (this.vehicleRegistrationUpload !== null) {
                formData.append('files', this.vehicleRegistrationUpload, this.vehicleRegistrationUpload.name);
            }  

            const uploadResponse = (
                await VatsAPI.post(
                    `/${this.location}/Permits/uploadDocuments/${permit.recID}`,
                    formData
                ).catch(error => {
                    this.$bvToast.toast(
                        this.i18nLocal('uploadError').toString(),
                        {
                            title: this.i18nCommon('error').toString(),
                            autoHideDelay: 5000
                        }
                    );
                }));
            const count = (uploadResponse as AxiosResponse).data;

            if (count > 0) {
                success = true;
            }
            else {
                this.$bvToast.toast(
                    this.i18nLocal('uploadError').toString(),
                    {
                        title: this.i18nCommon('error').toString(),
                        autoHideDelay: 5000
                    }
                );
            }

            return success;
        },
        async searchCustomer() {
            if (this.customer.recID !== null &&
                this.customer.recID >= 0) {
                const existingCustomer = (await VatsAPI.get(
                    `/${this.location}/Permits/customer/${this.customer.recID}`
                )).data;

                this.selectCustomer(existingCustomer);
            }
            else {
                this.customerSearchResults = (await VatsAPI.post(
                    `/${this.location}/Permits/searchPermitCustomerByCustomerData`,
                    {...this.customer}
                )).data;
            }
        },
        async updateCustomer() {
            if (this.existingCustomerSelected) {
                this.customer = ((await VatsAPI.post(
                    `/${this.location}/Permits/updatePermitCustomer`,
                    {...this.customer}
                ).catch(e => {
                    this.$bvToast.toast(
                        this.i18nLocal('customerUpdateError').toString(),
                        {
                            title: this.i18nCommon('error').toString(),
                            autoHideDelay: 5000
                        }
                    );
                })) as AxiosResponse).data;
            }
        },
        resetCustomer() {
            this.customer = {} as PermitCustomer;
        },
        async getNotes(customerRecId: number) {
            this.customerNotes = [];

            this.customerNotes = (await VatsAPI.post(
                `/${this.location}/Permits/getCustomerNotes/${customerRecId}`
            )).data;
        },
        async addCustomerNote(note: Note) {
            (await VatsAPI.post(
                `/${this.location}/Permits/addNote`,
                {
                    noteText: note.noteText,
                    customerRecID: this.customer.recID
                }
            ).catch(e => {
                this.$bvToast.toast(
                    this.i18nLocal('addNoteError').toString(),
                    {
                        title: this.i18nCommon('error').toString(),
                        autoHideDelay: 5000
                    }
                );
            }));

            await this.refreshCustomerNotes();
        },
        async refreshCustomerNotes() {
            if (this.existingCustomerSelected) {
                await this.getNotes(this.customer.recID);
            }
        },
        async selectCustomer(customer: PermitCustomer) {
            this.customer = {...customer};
            this.customerSearchResults = [];

            await this.refreshCustomerNotes();
        },
        async submitPermit() {
            if (!this.submissionComplete) {
                this.validationErrors = {};

                if (!this.submissionStatus.customer) {
                    this.submissionStatus.customer = await this.getOrCreateCustomer();
                }

                if (this.submissionStatus.customer) {
                    if (!this.submissionStatus.permit) {
                        this.submissionStatus.permit = await this.createPermit();
                    }

                    if (this.submissionStatus.permit) {
                        this.submissionStatus.permitTypeOverrides =
                            !this.isInternal || await this.overridePermitTypeFields();

                        if (this.submissionStatus.permitTypeOverrides) {
                            this.submissionStatus.documentUploads =
                                !this.settings.documentsRequired || await this.uploadDocuments(this.permit);

                            if (this.submissionComplete) {
                                this.$emit('permitAppliedFor', {...this.permit});
                            }
                        }
                    }
                }
            }
        },
        async getOrCreateCustomer(): Promise<boolean> {
            let existingCustomer = null;
            let success = true;

            if (this.existingCustomerSelected) {
                existingCustomer = this.customer;
            }
            else {
                existingCustomer = (await VatsAPI.post(
                    `/${this.location}/Permits/getExistingPermitCustomerByCustomerData`,
                    {...this.customer}
                )).data;
            }

            if (!existingCustomer) {
                existingCustomer = ((await VatsAPI.post(
                    `/${this.location}/Permits/createPermitCustomer`,
                    {...this.customer})
                    .catch(error => {
                        success = false;
                        this.validationErrors = getValidationErrors(error.response);
                        this.customerErrors = getValidationErrors(error.response);
                        this.$bvToast.toast(
                            this.i18nLocal('customerCreateError').toString(),
                            {
                                title: this.i18nCommon('error').toString(),
                                autoHideDelay: 5000
                            }
                        );
                    })
                ) as AxiosResponse).data;
            }

            if (success) {
                this.customer = existingCustomer;
            }

            return success;
        },
        checkDatesSelected() {
            if (this.permit.requestDateTime == null) {
                this.permit.requestDateTime = new Date();
            }

            if (new Date(this.permit.expirationDate!).getTime() < new Date(this.permit.requestDateTime!).getTime()) {
                return false;
            }

            if (this.selectedPermitType!.expirationType === undefined
            || this.selectedPermitType!.expirationType === '') {
                return true;
            }

            if (this.selectedPermitType!.expirationType === 'ANN') {
                if (countDays(this.permit.expirationDate!, this.permit.requestDateTime!) <= 365) {
                    return true;
                }
                return false;
            }

            if (this.selectedPermitType!.expirationType === 'NOE'
            || this.selectedPermitType!.expirationType === 'DAT') {
                return true;
            }

            const duration = this.selectedPermitType!.hasOwnProperty('expirationPeriodCount')
                    ? this.selectedPermitType!.expirationPeriodCount
                    : this.selectedPermitType!.duration === null || Number(this.selectedPermitType!.duration) === 0
                        ? 1
                        : Number(this.selectedPermitType!.duration);

            if (this.selectedPermitType!.expirationType.indexOf('M') === 0) {
                if (countDays(this.permit.expirationDate!, this.permit.requestDateTime!)
                    <= getDaysMonth(this.permit.requestDateTime!, duration)) {
                    return true;
                }
                return false;
            }

            if (this.selectedPermitType!.expirationType.indexOf('D') === 0) {
                if (countDays(this.permit.expirationDate!, this.permit.requestDateTime!) <= duration) {
                    return true;
                }
                return false;
            }
            if (this.selectedPermitType!.expirationType.indexOf('Q') === 0) {
                if (countDays(this.permit.expirationDate!, this.permit.requestDateTime!)
                    <= getQuarterCount(this.permit.requestDateTime!, duration)) {
                    return true;
                }
                return false;
            }
        },
        async selectCustomDate(values: { startDate: Date | null, endDate: Date | null }) {
            this.permit.expirationDate = values.endDate;
            this.permit.requestDateTime = values.startDate;
        },
        async createPermit(): Promise<boolean> {
            let success = true;

            // the description is used as the foreign key in the database
            this.permit.permitTypeID = this.selectedPermitType!.description;
            this.permit.customerRecID = this.customer.recID;

            if (this.selectedPermitType!.requiresDuration) {
                this.permit.duration = this.selectedPermitType!.duration;
            }

            const response = (await VatsAPI.post(this.permitCreationEndpoint, {...this.permit})
                .catch(error => {
                    this.validationErrors = getValidationErrors(error.response);
                    this.customerErrors = getValidationErrors(error.response);
                    success = false;

                    this.$bvToast.toast(
                        this.i18nLocal('applicationError').toString(),
                        {
                            title: this.i18nCommon('error').toString(),
                            autoHideDelay: 5000
                        }
                    );

                    // trigger re-evaluation of tab title classes
                    Vue.nextTick(() => {
                        this.nextTab();
                    });
                }));

            if (success) {
                this.permit = (response as AxiosResponse).data;
            }

            return success;
        },
        async overridePermitTypeFields() {
            // check for permit type overrides
            let success = true;
            const response = ((
                await VatsAPI.post(
                    `/${this.location}/Permits/override/${this.permit.recID}`,
                    {...this.selectedPermitType}
                )
            .catch(error => {
                success = false;
                this.validationErrors = getValidationErrors(error.response);
                this.customerErrors = getValidationErrors(error.response);

                this.$bvToast.toast(
                    this.i18nLocal('applicationError').toString(),
                    {
                        title: this.i18nCommon('error').toString(),
                        autoHideDelay: 5000
                    }
                );

                // trigger re-evaluation of tab title classes
                Vue.nextTick(() => {
                    this.nextTab();
                });
            })) as AxiosResponse);

            if (success) {
                this.permit = response.data;
            }

            return success;
        },
        addSharedVehicles() {
            this.permit.sharedVehicles = [];
            this.addingSharedVehicles = true;
        },
        async downloadDocument(entity: PermitApplicationDocument) {
            try {
                const response = (await VatsAPI.get<Blob>(`${this.location}/permits/documentAttachment`,
                    {
                        params: {
                            recId: entity.recID
                        },
                    headers: {
                        accept: constants.OctetMimeType
                    },
                    responseType: 'blob'
                }));
                fileSaver.saveAs(response.data, entity.fileName);
            }
            catch {
                this.$bvToast.toast(
                    this.i18nLocal('downloadError').toString(),
                    {
                        title: this.i18nCommon('error').toString(),
                        autoHideDelay: 5000
                    }
                );
            }
        },
    }
});

export default PermitApplication;
